import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import copy from 'clipboard-copy';


import styles from "../styles/components/copy-button.module.scss";

import { IconButton } from '@mui/material';
import classNames from 'classnames';


interface CopyButtonProps {
  content: string | number | null
  size?: 'small' | 'medium' | 'large'
}

export const CopyButton = ({
  content,
  size = 'small'
}: CopyButtonProps) => {
  return (
    <IconButton
      className={classNames(styles.copyButton, {
        [styles.small]: size === 'small',
        [styles.medium]: size === 'medium',
        [styles.large]: size === 'large'
      })}
      size={size}
      onClick={() => {
        const str = `${content}`
        copy(str)
      }
    }>
      <ContentCopyIcon />
    </IconButton>
  )
}